import { useState } from 'react';

const faqs = [
  {
    question: 'What is ACBuySpreadsheet?',
    answer: 'ACBuySpreadsheet is the leading ACBuy spreadsheet directory for 2026. It provides curated product links across 14 verified categories, helping shoppers find exactly what they are looking for without endless manual searching. Updated weekly with fresh links and the latest buying guides.',
  },
  {
    question: 'Is ACBuySpreadsheet safe to use?',
    answer: 'Yes, ACBuySpreadsheet prioritizes safety and trust. All links are verified before being added to the directory. We provide comprehensive safety guides, QC tips, and regularly review listings to ensure you have a secure shopping experience. Always check our safety guide for the latest tips.',
  },
  {
    question: 'How does ACBuySpreadsheet work?',
    answer: 'Simply browse our categorized directory or use the category dropdown to find products you need. Each category links to the corresponding section on KASpreadsheet with verified product listings. No sign-up is required — just explore and shop. Our guides help beginners navigate the entire process smoothly.',
  },
  {
    question: 'What products can I find on ACBuySpreadsheet?',
    answer: 'You can find a wide range of fashion and lifestyle products including shoes, hoodies, T-shirts, jackets, pants, headwear, matching sets, underwear, jerseys, accessories, bags, belts, perfumes, and more. The directory covers 14 categories with 5,000+ product links.',
  },
  {
    question: 'How often is the ACBuy spreadsheet updated?',
    answer: 'The ACBuySpreadsheet directory is updated weekly to ensure all product links remain current and active. Our editorial team regularly checks and refreshes listings, so you always have access to the most accurate and up-to-date shopping resources available in 2026.',
  },
  {
    question: 'Do I need an account to use ACBuySpreadsheet?',
    answer: 'No, ACBuySpreadsheet is completely free to use. There is no registration or account required. Simply visit the website, browse categories, and click through to the products you are interested in. Our goal is to make your shopping experience as seamless as possible.',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFaq = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <section id="faq" className="py-16 md:py-24 bg-background-100">
      <div className="w-full max-w-[900px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <p className="text-xs font-semibold text-primary-500 uppercase tracking-wider mb-3">
            Frequently Asked Questions
          </p>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            Got Questions About{' '}
            <span className="text-primary-500">ACBuySpreadsheet</span>?
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-xl mx-auto">
            Find answers to the most common questions about using the <strong>acbuy spreadsheet</strong> directory and getting the most out of your shopping experience.
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => toggleFaq(idx)}
                className="w-full flex items-center justify-between p-5 text-left cursor-pointer hover:bg-background-50/80 transition-colors"
              >
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  {faq.question}
                </h3>
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-background-100 flex items-center justify-center">
                  <i
                    className={`ri-${
                      openIndex === idx ? 'subtract' : 'add'
                    }-line text-foreground-700 transition-transform`}
                  ></i>
                </div>
              </button>
              {openIndex === idx && (
                <div className="px-5 pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}